import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cPresetCategory'})
export class CPresetCategoryPipe implements PipeTransform {
  static category = {
    most_talked : "Most talked about",
    most_viewed : "Most viewed",
    highest_rated : "Highest rated",
    other : "Other",
  };
  
  transform(input: string): string {
    return CPresetCategoryPipe.category[input] || 'N/A';
  }
}
